<div *ngIf="products$ | async as productsPage">
    <div class="product-search">
        <i class="far fa-search product-search-icon" aria-hidden="true"></i>
        <input
            type="text"
            class="product-search-input"
            placeholder="Search products by name, description, or part number"
            [formControl]="searchControl"
            autocomplete="off"
        />
        <button
            *ngIf="searchControl.value"
            type="button"
            class="product-search-clear"
            (click)="clearSearch()"
            aria-label="Clear search"
        >
            <i class="far fa-times" aria-hidden="true"></i>
        </button>
    </div>

    <div class="filter-section">
        <ng-container *ngIf="tags$ | async as tags">
            <div class="filter-row" *ngIf="tags.length">
                <span class="filter-row-label">Tags</span>
                <mat-radio-group class="filter-row-radios"
                    [value]="selectedTag"
                    (change)="onTagChange($event.value)">
                    <mat-radio-button [value]="0">All</mat-radio-button>
                    <mat-radio-button *ngFor="let t of tags" [value]="t.id">
                        {{ t.name }} ({{ t.count }})
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>
        <ng-container *ngIf="categories$ | async as categories">
            <div class="filter-row" *ngIf="categories.length">
                <span class="filter-row-label">Category</span>
                <mat-radio-group class="filter-row-radios"
                    [value]="selectedCategory"
                    (change)="onCategoryChange($event.value)">
                    <mat-radio-button [value]="''">All</mat-radio-button>
                    <mat-radio-button *ngFor="let c of categories" [value]="c.category">
                        {{ c.category }} ({{ c.count }})
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>
        <ng-container *ngIf="selectedCategory && (subcategories$ | async) as subcategories">
            <div class="filter-row filter-row-sub" *ngIf="subcategories.length">
                <span class="filter-row-label">Subcategory</span>
                <mat-radio-group class="filter-row-radios"
                    [value]="selectedSubcategory"
                    (change)="onSubcategoryChange($event.value)">
                    <mat-radio-button [value]="''">All</mat-radio-button>
                    <mat-radio-button *ngFor="let s of subcategories" [value]="s.subcategory">
                        {{ s.subcategory }} ({{ s.count }})
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>
        <!-- Brand filter temporarily disabled. Backend wiring stays intact; restore the
             template block (and uncomment selectedBrand on the component) to re-enable.
        <ng-container *ngIf="selectedSubcategory && (brands$ | async) as brands">
            <div class="filter-row filter-row-sub" *ngIf="brands.length > 1">
                <span class="filter-row-label">Brand</span>
                <mat-radio-group class="filter-row-radios"
                    [value]="selectedBrand"
                    (change)="onBrandChange($event.value)">
                    <mat-radio-button [value]="''">All</mat-radio-button>
                    <mat-radio-button *ngFor="let b of brands" [value]="b.brand">
                        {{ b.brand }} ({{ b.count }})
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>
        -->
    </div>

    <h4 class="text-center products-loading" *ngIf="loading">Loading...</h4>

    <ng-container *ngIf="!loading && productsPage.data.length">
        <ng-container [ngSwitch]="type">
            <ng-container *ngSwitchCase="'App\\Models\\PenProduct'">
                <app-display-pen-products
                    [products]="productsPage.data"
                    [sale]="sale"
                >
                </app-display-pen-products>
            </ng-container>

            <ng-container *ngSwitchDefault>
                <div class="products d-grid gap-lg w-100 position-relative">
                    <app-product-card
                        *ngFor="let family of (families$ | async) ?? []"
                        [descriptionLimit]="120"
                        [product]="family.primary"
                        [variants]="family.variants"
                        [selectedMap]="cart.selections"
                        [sale]="sale"
                        (toggle)="cart.toggle($event)"
                    ></app-product-card>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>

    <h4 class="text-center" *ngIf="!loading && !productsPage.data.length">No Products found for this deal</h4>

    <mat-paginator class="product-paginator" (page)="onPage()" [pageSize]="productsPage.per_page" [hidePageSize]="true" [length]="productsPage.total"></mat-paginator>
</div>
